module.exports = function(data) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }

 var cols = 12 / data.totals.length; ;
__p += '\n';
 data.totals.forEach(function(t, i) { ;
__p += '\n<div class="col-xs-' +
((__t = ( cols )) == null ? '' : __t) +
' data-regular ' +
((__t = ( t.className || '')) == null ? '' : __t) +
'">\n    <div class="wrap">\n        <div class="summary-block">\n            <div class="block-name">' +
((__t = ( t.name )) == null ? '' : __t) +
'</div>\n            <div class="block-value">' +
((__t = ( t.formattedValue )) == null ? '' : __t) +
'</div>\n        </div>\n    </div>\n</div>\n';
 }); ;
__p += '\n';
return __p
}